import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { AuthService } from '../../../../../core/services/auth.service';
import { AgencyDao } from '../../../../../core/services/dao/agencyDao';

@Injectable()
export class NewAgencyResolve implements Resolve<Observable<any>> {
  constructor(private authService: AuthService, private agencyDao: AgencyDao) {}

  resolve(route: ActivatedRouteSnapshot) {
    if (route.params.agencyId) {
      let agencyResolve = this.agencyDao.loadById(route.params.agencyId);
      let sessionResolve = this.authService.checkSession();
      return zip(sessionResolve, agencyResolve);
    } else {
      let sessionResolve = this.authService.checkSession();
      return zip(sessionResolve);
    }
  }
}
